const HOSTINGER_API_URL = process.env.REACT_APP_API_URL || 'https://onyxcrm.onyxmachinery.in/api.php';

let authToken = localStorage.getItem('onyx_auth_token') || null;

export const setAuthToken = (token) => {
    authToken = token;
    if (token) localStorage.setItem('onyx_auth_token', token);
    else localStorage.removeItem('onyx_auth_token');
};

export const getAuthToken = () => authToken;

const apiCall = async (action, payload = null) => {
    try {
        const options = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        };
        
        const data = payload ? { ...payload } : {};
        if (authToken && !data.token) {
            data.token = authToken;
        }
        
        options.body = JSON.stringify(data);
        
        const response = await fetch(`${HOSTINGER_API_URL}?action=${action}`, options);
        
        let result = null;
        let rawText = "";
        try {
            rawText = await response.clone().text();
            result = JSON.parse(rawText);
        } catch(e) {
            // It's not JSON! Probably an HTML fatal error or 403 Forbidden.
        }
        
        if (response.ok && result) {
            if (result.success) {
                return result.data !== undefined ? result.data : result;
            }
            return result;
        } else if (result) {
            return result;
        } else {
            // Include the raw text snippet so the user sees EXACTLY what PHP or Hostinger printed!
            const snippet = rawText ? rawText.substring(0, 100).replace(/<[^>]+>/g, ' ').trim() : '';
            return { success: false, message: `HTTP ${response.status}: ${snippet || response.statusText}` };
        }
    } catch (error) {
        console.error("API Error:", error);
        return { success: false, message: error.message };
    }
};

export { apiCall };
